<template>
    <FinanceData/>
</template>

<script>
import { FinanceData } from 'shared'

export default {
    name: 'financeData',
    components: {
        FinanceData
    },
    data() {
        return {
            params: {
                name: '跨境电商'
            }
        }
    },
    created() {
        this.$store.dispatch('getFinancing', this.params)
    },
}
</script>